import React, { useCallback } from 'react';

import * as Modal from 'app/components/common/modal/Modal';
import Analytics from 'app/lib/Analytics/Analytics';

import { ReactComponent as SpinnerIcon } from 'assets/icons/spinner.svg';

import { useDispatcher, useSelector } from 'app/store/utils/redux/hooks';
import { IPageGift } from 'app/store/nodes/card/interfaces';

import styles from './GiftError.module.css';

interface IGiftError {}

const GiftError: React.FC<IGiftError> = (props) => {
  const isLoading = useSelector((state) => state.gift.isLoading);

  const actions = useDispatcher();

  const handleTryAgain = useCallback(() => {
    Analytics.track().useGiftButtonTapped();
    actions.gift.useGift();
  }, [actions]);

  const handleClose = useCallback(() => {
    actions.gift.setGiftError(false);
  }, [actions]);

  return (
    <div className={styles.componentGiftError}>
      <div className={styles.body}>
        <div className={styles.title}>Something went wrong</div>
        <div>
          <p>Please try again.</p>
          <p>
            If it still doesn&apos;t work email us at
            {' '}
            <a className={styles.contact} href="mailto:info@cardsnacks.com">info@cardsnacks.com</a>
            {' or call us at '}
            <a className={styles.contact} href="tel:+19143202969">914-570-4230</a>
          </p>
        </div>
        <div className={styles.buttons}>
          <button type="button" onClick={handleClose} className={styles.cancel}><span>cancel</span></button>
          {isLoading && (
            // eslint-disable-next-line jsx-a11y/control-has-associated-label
            <button type="button" className={styles.tryAgain}><SpinnerIcon /></button>
          )}
          {!isLoading && (
            <button type="button" onClick={handleTryAgain} className={styles.tryAgain}>try again</button>
          )}
        </div>
      </div>
    </div>
  );
};

const ProxyGiftError: React.FC<IGiftError> = (props) => {
  const isOpen = useSelector((state) => state.gift.hasError);

  const page = useSelector((state) => {
    return state?.card?.pages[state?.flipbook?.currentPage] as IPageGift;
  });

  const actions = useDispatcher();

  const handleClose = useCallback(() => {
    actions.gift.setGiftError(false);
  }, [actions]);

  if (page?.type !== 'PageGift') {
    return null;
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return (
    <Modal.Item
      visible={isOpen}
      hAlign="center"
      vAlign="flex-start"
      onOutsideClick={handleClose}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <GiftError {...props} />
    </Modal.Item>
  );
};

export default ProxyGiftError;
